import React, { createContext, useCallback, useContext, useMemo } from "react";

const DEVICE_KEY = "trufitapp_edit_unlocked";

const EditLockContext = createContext(null);

/** Edit lock retired — always unlocked (was 5 taps). API kept so callers don't break. */
export function EditLockProvider({ children }) {
  try {
    localStorage.setItem(DEVICE_KEY, "1");
  } catch {
    // ignore
  }

  const registerUnlockTap = useCallback(() => {}, []);

  const ctx = useMemo(
    () => ({ canEdit: true, registerUnlockTap, tapProgress: 0, tapGoal: 0 }),
    [registerUnlockTap]
  );

  return <EditLockContext.Provider value={ctx}>{children}</EditLockContext.Provider>;
}

export function useEditLock() {
  const ctx = useContext(EditLockContext);
  if (!ctx) throw new Error("useEditLock must be used within EditLockProvider");
  return ctx;
}
